import {
  calculatorAndToolsName,
  calculatorAndToolsResoucesLandingSlugs,
  calculatorAndToolsSlugs,
  headerSlugs,
  headerTitle,
  repo,
} from "../utils/commonRouteUrl";

const headerLeftMockData = [
  {
    key: "dashboard",
    name: headerTitle?.dashboard,
    icon: "fa-fw fa-light fa-desktop",
    route: headerSlugs?.dashboard,
    backupRoute: headerSlugs?.dashboard,
    repo: repo?.react,
    subMenu: true,
    beta: false,
    betaText: "",
    proRoute: false,
    id: "dashboardMenu",
  },
  {
    key: "my_account",
    name: headerTitle?.myAccount,
    icon: "fa-fw fa-light fa-user-lock",
    route: headerSlugs?.myAccount,
    backupRoute: headerSlugs?.myAccount,
    repo: repo?.next,
    subMenu: true,
    beta: false,
    betaText: "",
    proRoute: false,
    noRoute: false,
    subRoutes: [
      {
        key: "my_account_therapist_information",
        name: headerTitle?.therapistInformation,
        icon: "fa-fw fa-light fa-user",
        route: headerSlugs?.therapistInformation,
        backupRoute: headerSlugs?.therapistInformation,
        repo: repo?.next,
        proRoute: false,
      },
      {
        key: "my_account_business_information",
        name: headerTitle?.businessInformation,
        icon: "fa-fw fa-light fa-briefcase",
        route: headerSlugs?.businessInformation,
        backupRoute: headerSlugs?.businessInformation,
        repo: repo?.next,
        proRoute: false,
      },
      {
        key: "my_account_my_subscription",
        name: headerTitle?.mySubscription,
        icon: "fa-fw fa-light fa-receipt",
        route: headerSlugs?.mySubscription,
        backupRoute: headerSlugs?.mySubscription,
        repo: repo?.next,
        proRoute: false,
      },
      {
        key: "my_account_payments",
        name: headerTitle?.myPayments,
        icon: "fa-fw fa-light fa-dollar-sign",
        route: headerSlugs?.myPayments,
        backupRoute: headerSlugs?.myPayments,
        repo: repo?.next,
        proRoute: false,
      },
      {
        key: "my_account_settings",
        name: headerTitle?.myAccountSettings,
        icon: "fa-fw fa-light fa-cog",
        route: headerSlugs?.myAccountSettings,
        backupRoute: headerSlugs?.myAccountSettings,
        repo: repo?.next,
        proRoute: false,
      },
    ],
    id: "userLeftMenu",
  },
  {
    key: "toolbox",
    name: calculatorAndToolsName?.toolbox,
    icon: "fa-light fa-objects-column",
    route: calculatorAndToolsSlugs.toolbox,
    backupRoute: calculatorAndToolsSlugs.toolbox,
    repo: repo?.next,
    subMenu: true,
    proRoute: false,
    beta: false,
    noRoute: false,
    betaText: "",
    subRoutes: [
      {
        key: "therapy_note_generator",
        name: calculatorAndToolsName?.therapyNotesGeneratorName(),
        icon: "fa-fw fa-light fa-file-zipper",
        route: calculatorAndToolsSlugs.therapyNotesGenerator(),
        backupRoute: calculatorAndToolsResoucesLandingSlugs?.therapyNotesGenerator(),
        repo: repo?.next,
        beta: false,
        betaText: "New Tool",
        proRoute: true,
      },
      {
        key: "practice_form_generator",
        name: calculatorAndToolsName?.paperworkAndFormGeneratorName(),
        icon: "fa-fw fa-light fa-file-lines",
        route: calculatorAndToolsSlugs.paperworkAndFormGenerator(),
        backupRoute: calculatorAndToolsSlugs.paperworkAndFormGenerator(),
        repo: repo?.next,
        beta: false,
        betaText: "New Tool",
        proRoute: false,
      },
      {
        key: "therapist_deduction_calculator",
        name: calculatorAndToolsName?.therapistDeductionsCalculatorName(),
        icon: "fa-fw fa-light fa-piggy-bank",
        route: calculatorAndToolsSlugs.therapistDeductionsCalculator(),
        backupRoute: calculatorAndToolsResoucesLandingSlugs?.therapistDeductionsCalculator(),
        repo: repo?.next,
        beta: false,
        betaText: "",
        proRoute: false,
        premiumRoute: true,
      },
      {
        key: "session_fee_calculator",
        name: calculatorAndToolsName?.sessionFeeCalculatorName(),
        icon: "fa-fw fa-light fa-gem",
        route: calculatorAndToolsSlugs.sessionFeeCalculator(),
        backupRoute: calculatorAndToolsSlugs.sessionFeeCalculator(),
        repo: repo?.next,
        beta: false,
        betaText: "",
        proRoute: false,
      },
      {
        key: "good_faith_estimate_calculator",
        name: calculatorAndToolsName?.goodFaithEstimateCalculatorName(),
        icon: "fa-fw fa-light fa-hand-holding-medical",
        route: calculatorAndToolsSlugs.goodFaithEstimateCalculator(),
        backupRoute: calculatorAndToolsResoucesLandingSlugs?.goodFaithEstimateCalculator(),
        repo: repo?.next,
        beta: false,
        betaText: "",
        proRoute: true,
      },
      {
        key: "out_of_network_calculator",
        name: calculatorAndToolsName?.outOfNetworkCalculatorName(),
        icon: "fa-fw fa-light fa-envelope-open-dollar",
        route: calculatorAndToolsSlugs.outOfNetworkCalculator(),
        backupRoute: calculatorAndToolsResoucesLandingSlugs?.outOfNetworkCalculator(),
        repo: repo?.next,
        beta: false,
        betaText: "",
        proRoute: true,
      },
      {
        key: "superbill_generator",
        name: calculatorAndToolsName?.superbillGenerator(),
        icon: "fa-fw fa-light fa-file-invoice-dollar",
        route: calculatorAndToolsSlugs.superbillGenerator(),
        backupRoute: calculatorAndToolsResoucesLandingSlugs?.superbillGenerator(),
        repo: repo?.next,
        beta: false,
        betaText: "New Tool",
        proRoute: true,
      },
    ],
    id: "toolboxLeftMenu",
  },
  {
    key: "library",
    name: headerTitle?.library,
    icon: "fa-books",
    // route: headerSlugs?.library,
    backupRoute: headerSlugs?.library,
    repo: repo?.react,
    subMenu: true,
    proRoute: false,
    beta: false,
    noRoute: true,
    betaText: "",
    subRoutes: [
      {
        key: "resource",
        name: headerTitle?.resource,
        icon: "fa-fw fa-light fa-desktop",
        route: headerSlugs?.resource,
        backupRoute: headerSlugs?.resource,
        repo: repo?.react,
        beta: false,
        betaText: "",
        proRoute: false,
      },
      {
        key: "blog",
        name: headerTitle?.blog,
        icon: "fa-light fa-user-tie",
        route: headerSlugs?.blog,
        backupRoute: headerSlugs?.blog,
        repo: repo?.next,
        beta: false,
        betaText: "",
        proRoute: false,
      },
    ],
    id: "libraryMenu",
  },
  {
    key: "market_place",
    name: headerTitle?.marketPlace,
    icon: "fa-store",
    // route: headerSlugs?.marketPlace,
    backupRoute: headerSlugs?.marketPlace,
    repo: repo?.react,
    subMenu: true,
    proRoute: false,
    beta: false,
    betaText: "",
    noRoute: true,
    subRoutes: [
      {
        key: "health_insurance",
        name: headerTitle?.healthInsurance,
        icon: "fa-fw fa-light fa-shield-plus",
        route: headerSlugs?.healthInsurance,
        backupRoute: headerSlugs?.healthInsurance,
        repo: repo?.react,
        beta: false,
        betaText: "",
        proRoute: false,
      },
      {
        key: "dental_insurance",
        name: headerTitle?.dentalInsurance,
        icon: "fa-fw fa-light fa-tooth",
        route: headerSlugs?.dentalInsurance,
        backupRoute: headerSlugs?.dentalInsurance,
        repo: repo?.react,
        beta: false,
        betaText: "",
        proRoute: false,
      },
      {
        key: "vision_insurance",
        name: headerTitle?.visionInsurance,
        icon: "fa-fw fa-light fa-eye",
        route: headerSlugs?.visionInsurance,
        backupRoute: headerSlugs?.visionInsurance,
        repo: repo?.react,
        beta: false,
        betaText: "",
        proRoute: false,
      },
      {
        key: "member_benefits",
        name: headerTitle?.memberBenefits,
        icon: "fa-fw fa-light fa-gift",
        route: headerSlugs?.memberBenefits,
        backupRoute: headerSlugs?.memberBenefits,
        repo: repo?.next,
        beta: false,
        betaText: "",
        proRoute: false,
      },
    ],
    id: "marketPlaceMenu",
  },
  {
    key: "community",
    name: headerTitle?.community,
    icon: "fa-fw fa-light fa-users",
    route: headerSlugs?.community,
    backupRoute: headerSlugs?.community,
    repo: repo?.react,
    subMenu: true,
    proRoute: false,
    subRoutes: [
      {
        key: "community_explore_forum",
        name: headerTitle?.communityExploreForum,
        icon: "fa-fw fa-light fa-comments",
        route: headerSlugs?.communityExploreForum,
        backupRoute: headerSlugs?.communityExploreForum,
        repo: repo?.next,
        beta: false,
        betaText: "",
        proRoute: false,
        openInNewTabUrl: true,
      },
      {
        key: "community_attend_live_sessions",
        name: headerTitle?.communityAttendLiveSession,
        icon: "fa-fw fa-light fa-tv-music",
        route: headerSlugs?.communityAttendLiveSession,
        backupRoute: headerSlugs?.communityAttendLiveSession,
        repo: repo?.next,
        beta: false,
        betaText: "New Tool",
        proRoute: false,
        openInNewTabUrl: true,
      },
      {
        key: "community_join_groups",
        name: headerTitle?.communityJoinGroups,
        icon: "fa-fw fa-light fa-users",
        route: headerSlugs?.communityJoinGroups,
        backupRoute: headerSlugs?.communityJoinGroups,
        repo: repo?.next,
        beta: false,
        betaText: "New Tool",
        proRoute: false,
        openInNewTabUrl: true,
      },
      {
        key: "community_connect_network",
        name: headerTitle?.communityConnectNetwork,
        icon: "fa-fw fa-light fa-network-wired",
        route: headerSlugs?.communityConnectNetwork,
        backupRoute: headerSlugs?.communityConnectNetwork,
        repo: repo?.next,
        beta: false,
        betaText: "",
        proRoute: false,
        openInNewTabUrl: true,
      },
      {
        key: "community_meet_members",
        name: headerTitle?.communityMeetMembers,
        icon: "fa-fw fa-light fa-handshake-simple",
        route: headerSlugs?.communityMeetMembers,
        backupRoute: headerSlugs?.communityMeetMembers,
        repo: repo?.next,
        beta: false,
        betaText: "",
        proRoute: false,
        openInNewTabUrl: true,
      },
    ],
    id: "communityLeftMenu",
  },
  {
    key: "notification",
    name: headerTitle?.notification,
    icon: "fa-bell",
    route: "",
    noRoute: true,
    id: "notificationMenu",
  },
  {
    key: "my_patients",
    name: headerTitle?.myPatients,
    icon: "fa-light fa-user-tie",
    route: headerSlugs?.myPatients,
    backupRoute: headerSlugs?.myPatients,
    repo: repo?.next,
    subMenu: true,
    beta: false,
    betaText: "",
    proRoute: true,
    id: "myPatientMenu",
  },
  {
    key: "support",
    name: headerTitle?.support,
    icon: "fa-circle-info",
    // route: headerSlugs?.support,
    backupRoute: headerSlugs?.support,
    repo: repo?.react,
    subMenu: true,
    proRoute: false,
    beta: false,
    betaText: "",
    noRoute: true,
    subRoutes: [
      {
        key: "about",
        name: headerTitle?.about,
        icon: "fa-fw fa-light fa-circle-info",
        route: headerSlugs?.about,
        backupRoute: headerSlugs?.about,
        repo: repo?.react,
        beta: false,
        betaText: "",
        proRoute: false,
      },
      {
        key: "help",
        name: headerTitle?.help,
        icon: "fa-fw fa-light fa-circle-question",
        route: "",
      },
      {
        key: "video_tutorials",
        name: headerTitle?.videoTutorial,
        repo: repo?.next,
        route: headerSlugs?.videoTutorial,
        backupRoute: headerSlugs?.videoTutorial,
        icon: "fa fa-light fa-video",
      },
      {
        key: "report_a_problem",
        name: headerTitle?.reportAProblem,
        icon: "fa-light fa-circle-info",
        route: headerSlugs?.reportAProblem,
        backupRoute: headerSlugs?.reportAProblem,
        repo: repo?.react,
        beta: false,
        betaText: "",
        proRoute: false,
      },
      {
        key: "request_a_feature",
        name: headerTitle?.requestAFeature,
        icon: "fa-light fa-lightbulb-on",
        route: headerSlugs?.requestAFeature,
        backupRoute: headerSlugs?.requestAFeature,
        repo: repo?.react,
        beta: false,
        betaText: "",
        proRoute: false,
      },
    ],
    id: "supportMenu",
  },
  {
    key: "dashboard_invite_friend",
    name: headerTitle?.inviteFriend,
    icon: "fa-user-plus",
    route: headerSlugs?.inviteFriend,
    backupRoute: headerSlugs?.inviteFriend,
    repo: repo?.react,
    subMenu: true,
    beta: false,
    betaText: "",
    proRoute: false,
    id: "inviteFriendMenu",
  },
];
export default headerLeftMockData;
